<template>
  <el-select
    v-model="productId"
    filterable
    clearable
    :placeholder="placeholder"
    :loading="loading"
    @change="handleChange">
    <el-option
      v-for="item in options"
      :key="item.warehouseNo"
      :label="item.warehouseName"
      :value="item.warehouseNo">
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'EntWarehouseAutoSelect',
  components: {},
  props: {
    value: {
      required: true
    },
    placeholder: {
      type: String,
      default: '请输入仓库名称'
    },
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      options: []
    }
  },
  computed: {
    productId: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {},
  created() { },
  mounted() {
    this.fetch()
  },
  methods: {
    handleChange() {
      this.callback && this.callback()
    },
    fetch() {
      this.loading = true
      this.$store.dispatch('outstock/getwarehouses', {
        payload: {
          pageNum: 1,
          pageSize: 10000,
          vendorId: null
          // productType: 1,
          // useType: 1
        },
        success: (res) => {
          this.loading = false
          this.options = res.data.records.map(i => {
            return {
              ...i,
              warehouseName: `${i.warehouseName}(${i.warehouseNo})`
            }
          })
        },
        fail: () => {
          this.loading = false
          this.options = []
        }
      })
    }
  }
}
</script>
